/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBaselineDensityLarge = createReactComponent(
  "baseline-density-large",
  "IconBaselineDensityLarge",
  [
    ["path", { d: "M4 4h16", key: "svg-0" }],
    ["path", { d: "M4 20h16", key: "svg-1" }]
  ]
);

export { IconBaselineDensityLarge as default };
//# sourceMappingURL=IconBaselineDensityLarge.js.map
